import { StyleSheet, Dimensions } from "react-native";
import { FlickOColors, FlickOTheme } from "./color";

const { width, height } = Dimensions.get("window");

export const getResponsiveSize = (baseSize: number): number => {
  let { width, height } = Dimensions.get("window");
  const scaleFactor = width < 375 ? 0.8 : width > 768 ? 1.2 : 1;
  return baseSize * scaleFactor;
};

export const loginStyles = StyleSheet.create({
  wrapper: {
    padding: getResponsiveSize(16),
    maxWidth: width > 1024 ? "80%" : 1200,
    alignSelf: "center",
    width: "100%",
  },
  content: {
    flexDirection: width > 768 ? "row" : "column",
    gap: getResponsiveSize(16),
    marginTop: getResponsiveSize(24),
  },
  sidebar: {
    width: 320,
    gap: getResponsiveSize(16),
  },
  fullWidth: {
    width: "100%",
  },
  card: {
    backgroundColor: FlickOColors.white,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
    overflow: "hidden",
  },

  // New styles for map
  mapSection: {
    marginTop: getResponsiveSize(24),
  },
  mapCard: {
    height: getResponsiveSize(300),
    borderRadius: 12,
    overflow: "hidden",
  },
  mapHeader: {
    padding: getResponsiveSize(16),
    borderBottomWidth: 1,
    borderBottomColor: FlickOColors.gray.light,
  },
  mapContainer: {
    flex: 1,
  },
  searchContainer: {
    position: "relative",
    marginBottom: getResponsiveSize(16),
  },
  loader: {
    position: "absolute",
    right: getResponsiveSize(12),
    top: getResponsiveSize(12),
  },
  resultsContainer: {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    backgroundColor: FlickOColors.white,
    borderRadius: 8,
    elevation: 4,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    zIndex: 1000,
  },
  resultItem: {
    padding: getResponsiveSize(12),
    borderBottomWidth: 1,
    borderBottomColor: FlickOColors.gray.light,
  },
  resultText: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.primary,
  },
  container: {
    flex: 1,
    backgroundColor: FlickOColors.white,
    alignItems: "center",
    justifyContent: "space-between",
    padding: getResponsiveSize(FlickOTheme.spacing.lg),
  },
  logoContainer: {
    alignItems: "center",
    marginTop: getResponsiveSize(FlickOTheme.spacing.lg),
  },
  logo: {
    fontSize: getResponsiveSize(32),
    fontWeight: "bold",
    color: FlickOColors.primary,
  },
  tagline: {
    fontSize: getResponsiveSize(FlickOTheme.fontSizes.medium),
    color: FlickOColors.text.secondary,
    marginTop: FlickOTheme.spacing.sm,
    textAlign: "center",
  },
  zeroCommissionTagline: {
    fontSize: getResponsiveSize(FlickOTheme.fontSizes.medium),
    color: FlickOColors.text.secondary,
    marginTop: FlickOTheme.spacing.xs,
  },
  illustrationContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    maxHeight: height * 0.4,
  },
  illustration: {
    width: "90%",
    height: "100%",
    maxHeight: 300,
    maxWidth: 500,
  },
  buttonContainer: {
    width: "100%",
    paddingHorizontal: width > 768 ? "20%" : "10%",
    marginVertical: getResponsiveSize(FlickOTheme.spacing.lg),
  },
  loginButton: {
    backgroundColor: FlickOColors.primary,
    padding: getResponsiveSize(FlickOTheme.spacing.md),
    borderRadius: FlickOTheme.borderRadius.md,
    alignItems: "center",
    marginBottom: FlickOTheme.spacing.md,
  },
  registerButton: {
    borderColor: FlickOColors.primary,
    borderWidth: 2,
    padding: getResponsiveSize(FlickOTheme.spacing.md),
    borderRadius: FlickOTheme.borderRadius.md,
    alignItems: "center",
  },
  buttonText: {
    color: FlickOColors.white,
    fontSize: getResponsiveSize(FlickOTheme.fontSizes.large),
    fontWeight: "bold",
  },
  registerButtonText: {
    color: FlickOColors.primary,
    fontSize: getResponsiveSize(FlickOTheme.fontSizes.large),
    fontWeight: "bold",
  },
  contactContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: FlickOTheme.spacing.md,
  },
  contactText: {
    color: FlickOColors.text.secondary,
    fontSize: getResponsiveSize(FlickOTheme.fontSizes.small),
  },
  subSection: {
    color: FlickOColors.text.secondary,
    fontSize: getResponsiveSize(FlickOTheme.fontSizes.small),
    marginBottom: getResponsiveSize(24),
  },
  headerContainer: {
    marginTop: getResponsiveSize(FlickOTheme.spacing.xl),
  },
  title: {
    fontSize: getResponsiveSize(24),
    fontWeight: "bold",
    color: FlickOColors.primary,
    marginBottom: FlickOTheme.spacing.md,
  },
  subtitle: {
    fontSize: getResponsiveSize(16),
    color: FlickOColors.text.secondary,
    marginBottom: FlickOTheme.spacing.lg,
  },
  inputContainer: {
    flexDirection: "row",
    marginBottom: FlickOTheme.spacing.md,
  },
  countryCodeContainer: {
    backgroundColor: FlickOColors.gray.light,
    paddingHorizontal: FlickOTheme.spacing.sm,
    justifyContent: "center",
    borderTopLeftRadius: FlickOTheme.borderRadius.sm,
    borderBottomLeftRadius: FlickOTheme.borderRadius.sm,
  },
  countryCodeText: {
    fontSize: getResponsiveSize(16),
  },
  phoneInput: {
    flex: 1,
    borderWidth: 1,
    borderColor: FlickOColors.gray.medium,
    paddingHorizontal: FlickOTheme.spacing.sm,
    paddingVertical: FlickOTheme.spacing.sm,
    borderTopRightRadius: FlickOTheme.borderRadius.sm,
    borderBottomRightRadius: FlickOTheme.borderRadius.sm,
  },
  errorInput: {
    borderColor: FlickOColors.error,
  },
  errorText: {
    color: FlickOColors.error,
    fontSize: getResponsiveSize(12),
    marginBottom: FlickOTheme.spacing.sm,
  },
  submitButton: {
    backgroundColor: FlickOColors.primary,
    padding: getResponsiveSize(FlickOTheme.spacing.md),
    borderRadius: FlickOTheme.borderRadius.md,
    alignItems: "center",
    marginTop: FlickOTheme.spacing.md,
  },
  submitButtonText: {
    color: FlickOColors.white,
    fontSize: getResponsiveSize(FlickOTheme.fontSizes.large),
    fontWeight: "bold",
  },
  registerContainer: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: FlickOTheme.spacing.lg,
  },
  registerText: {
    color: FlickOColors.text.secondary,
  },
  registerLink: {
    color: FlickOColors.primary,
    fontWeight: "bold",
  },
  modalContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  modalContent: {
    backgroundColor: FlickOColors.white,
    padding: getResponsiveSize(20),
    borderRadius: 10,
    width: "90%",
    maxWidth: 400,
  },
  otpContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: getResponsiveSize(20),
  },
  otpInput: {
    width: getResponsiveSize(40),
    height: getResponsiveSize(50),
    borderWidth: 1,
    borderColor: FlickOColors.gray.medium,
    textAlign: "center",
    fontSize: getResponsiveSize(20),
    borderRadius: 5,
  },
  timerContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: getResponsiveSize(20),
  },
  timerText: {
    color: FlickOColors.text.secondary,
    fontSize: getResponsiveSize(FlickOTheme.fontSizes.small),
  },
  resendText: {
    color: FlickOColors.primary,
    fontWeight: "bold",
    fontSize: getResponsiveSize(FlickOTheme.fontSizes.small),
  },
  disabledText: {
    color: FlickOColors.gray.medium,
  },
  disabledButton: {
    opacity: 0.5,
  },
  closeButton: {
    alignItems: "center",
    marginTop: getResponsiveSize(10),
  },
  heroContainer: {
    width: "100%",
    backgroundColor: FlickOColors.white,
    paddingVertical: getResponsiveSize(40),
  },
  backgroundImage: {
    position: "absolute",
    width: "100%",
    height: "100%",
  },
  contentContainer: {
    width: "100%",
    maxWidth: 1200,
    marginHorizontal: "auto",
    paddingHorizontal: getResponsiveSize(20),
  },
  mainHeading: {
    marginTop: getResponsiveSize(30),
    fontSize: getResponsiveSize(30),
    fontWeight: "bold",
    color: FlickOColors.primary,
    textAlign: "center",
    marginBottom: getResponsiveSize(8),
  },
  subHeading: {
    fontSize: getResponsiveSize(20),
    fontWeight: "bold",
    color: FlickOColors.text.primary,
    textAlign: "center",
  },
  headerTextContainer: {
    alignItems: "center",
    marginBottom: getResponsiveSize(40),
  },
  getStartedContainer: {
    flexDirection: width > 768 ? "row" : "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    backgroundColor: FlickOColors.white,
    borderRadius: 12,
    padding: getResponsiveSize(24),
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  checklistContainer: {
    flex: 1,
    marginRight: width > 768 ? getResponsiveSize(40) : 0,
    marginBottom: width > 768 ? 0 : getResponsiveSize(24),
  },
  checklistItem: {
    flexDirection: "row",
    alignItems: "center",
    margin: getResponsiveSize(8),
  },
  checkIcon: {
    marginRight: getResponsiveSize(12),
  },
  videoContainer: {
    width: width > 768 ? "40%" : "100%",
    aspectRatio: 16 / 9,
    borderRadius: 8,
    overflow: "hidden",
    backgroundColor: FlickOColors.gray.light,
  },
  webview: {
    flex: 1,
    backgroundColor: "transparent",
  },
  sectionContainer: {
    paddingVertical: getResponsiveSize(60),
    backgroundColor: FlickOColors.white,
  },
  sectionHeader: {
    alignItems: "center",
    marginBottom: getResponsiveSize(40),
  },
  sectionTitle: {
    fontSize: getResponsiveSize(32),
    fontWeight: "bold",
    color: FlickOColors.text.primary,
    textAlign: "center",
  },
  sectionSubtitle: {
    fontSize: getResponsiveSize(16),
    color: FlickOColors.text.secondary,
    textAlign: "center",
    marginTop: getResponsiveSize(8),
  },
  benefitsGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: getResponsiveSize(24),
  },
  benefitCard: {
    width: width > 1024 ? "30%" : width > 768 ? "45%" : "100%",
    padding: getResponsiveSize(24),
    backgroundColor: FlickOColors.white,
    borderRadius: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  benefitIconContainer: {
    width: getResponsiveSize(64),
    height: getResponsiveSize(64),
    borderRadius: getResponsiveSize(32),
    backgroundColor: FlickOColors.gray.light,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: getResponsiveSize(16),
  },
  benefitTitle: {
    fontSize: getResponsiveSize(20),
    fontWeight: "600",
    color: FlickOColors.text.primary,
    marginBottom: getResponsiveSize(8),
  },
  benefitDescription: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
    lineHeight: getResponsiveSize(20),
  },
});
